// extracted by mini-css-extract-plugin
module.exports = {"mentionList":"MentionList_mentionList__0gla6"};